import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_GET_ZOHO_CONFIG, API_POST_ZOHO_AUTH, API_POST_ZOHO_UNSYNC } from "../api/marketplace.service";

const initialState = {
  zohoConfig: {},
  isZohoSync: false,
  isLoading: false,
  error: false,
};

export const getZohoConfig = createAsyncThunk(
  "marketplace/zoho/getZohoConfig",
  async (formData, thunkAPI) => {
    try {
      const response = await API_GET_ZOHO_CONFIG(formData);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const unsyncZohoConfig = createAsyncThunk(
  "marketplace/zoho/unsyncZohoConfig",
  async (_, thunkAPI) => {
    try {
      const response = await API_POST_ZOHO_UNSYNC();
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
export const addZohoAuth = createAsyncThunk(
  "marketplace/zoho/addZohoAuth",
  async (data, thunkAPI) => {
    try {
      const response = await API_POST_ZOHO_AUTH(data);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

const marketPlaceSlice = createSlice({
  name: "marketPlace",
  initialState,
  reducers: {
    resetError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getZohoConfig.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getZohoConfig.fulfilled, (state, action) => {
      state.isLoading = false;
      state.zohoConfig = action.payload?.rows[0];
    });
    builder.addCase(getZohoConfig.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload || action.error.message;
    });
    builder.addCase(unsyncZohoConfig.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(unsyncZohoConfig.fulfilled, (state, action) => {
      state.isLoading = false;
      state.zohoConfig = {};
    });
    builder.addCase(unsyncZohoConfig.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload || action.error.message;
    });

    builder.addCase(addZohoAuth.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(addZohoAuth.fulfilled, (state, action) => {
      state.isLoading = false;
      // state.company = action.payload;
    });
    builder.addCase(addZohoAuth.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload || action.error.message;
    });
  },
});

export const { resetError } = marketPlaceSlice.actions;
export default marketPlaceSlice.reducer;
